<template>
	<div class="pa-2 pb-0">
		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			:module="'leaveOrPermission/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="fetchVacationTypes()">
			<!-- {{ $T('.delete-message') }} -->
			هل أنت متأكد من أنك تريد حذف  نوع الإجازة هذا ؟
		</v-delete-dialog>
		<v-row
			align="center"
			dense
			class="mb-1">
			<v-col cols="2">
				<v-autocomplete
					v-model="leaveTypeId"
					:items="leaves"
					item-text="name"
					item-value="id"
					label="نوع الإجازة "
					outlined
					dense
					hide-details
					clearable
				/>
			</v-col>
			<v-spacer></v-spacer>
			<v-col cols="auto">
				<v-btn
					@click="showAddVacationDialog = true"
					small
					dark
					depressed
					color="primary">
					<v-icon left> $add </v-icon>
					إضافة نوع إجازة
				</v-btn>
			</v-col>
		</v-row>
		<bee-handy-table
			ref="table"
			:headers="tableHeaders"
			:items="loading ? [] : leaveTypeId ? items.filter(c => c.id === leaveTypeId) : items"
			:data-table-props="{ disableSort: true }"
			:loading="loading"
			dense
			zebra
			fixed-header
			:height="$vuetify.breakpoint.height - 120"
			hide-default-footer
			:items-per-page="-1"
			>
			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<!-- vacations.ref = $refs.vacationsTable;
					vacations.ref.activeEditForRow(index);
					vacations.editId = item.id; -->
					<tooltip :text="$T('tooltips.edit')">
						<v-btn
							depressed
							rounded
							icon
							small
							@click="
								itemId = item.id;
								showAddVacationDialog = true
							">
							<v-icon
								size="20"
								color="edit-color">
								$edit
							</v-icon>
						</v-btn>
					</tooltip>

					<tooltip :text="$T('tooltips.delete')">
						<v-btn
							depressed
							rounded
							icon
							small
							@click="
								itemId = item.id;
								deleteDialog = true
							">
							<v-icon
								size="20"
								color="alert-color">
								$delete
							</v-icon>
						</v-btn>
					</tooltip>
					
				</div>
			</template>
		</bee-handy-table>

		<!-- add vacation -->
		<v-dialog
			v-model="showAddVacationDialog"
			:max-width="450"
			transition="dialog-transition"
			persistent>
			<v-card elevation="3">
				<v-form>
					<v-card-title primary-title>
						إضافة نوع إجازة
						<v-spacer></v-spacer>
						<v-btn
							@click="showAddVacationDialog = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="6">
								<v-checkbox
									v-model="addVacation.forAllEmployee"
									class="mt-0"
									outlined
									dense
									label="لكل الموظفين"
									hide-details></v-checkbox>
							</v-col>

							<v-col
								cols="12"
								v-if="!addVacation.forAllEmployee">
								<v-autocomplete
									v-model="addVacation.employees"
									:items="employees"
									:disabled="!employees.length"
									:loading="!employees.length"
									multiple
									:return-object="false"
									item-value="employeeId"
									:label="$T('employee')"
									:filter="
										(item, queryText) =>
											item.code?.includes(queryText) ||
											item.arabicFullName.includes(queryText)
									"
									dense
									outlined
									hide-details
									clearable
								>
									<template v-slot:item="{ item }">
										<div
											class="d-flex justify-space-between text-caption"
											style="width: 100%">
											<div>
												({{ item.code }})
												{{ item.arabicFullName }}
											</div>
											<div>
												{{ item.sectionName }}
											</div>
										</div>
									</template>
									<template v-slot:selection="{ item, index }">
										<div
											v-if="index < 20"
											class="d-flex justify-space-between"
											style="min-width: 100%">
											<div>
												({{ item.code }})
												{{ item.arabicFullName }}
											</div>
											<div>
												{{ item.sectionName }}
											</div>
										</div>
										<span
											v-if="index === 20"
											class="text-caption text-start"
											style="width: 100%">
											+{{ addVacation.employees?.length - 20 }}
											موظف اخرون
										</span>
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="addVacation.name"
									outlined
									dense
									label="الاسم"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model.number="addVacation.maxDayCount"
									outlined
									dense
									label="عدد الأيام الأعظمي"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="addVacation.repetition"
									:items="Object.values(vacationFrequency)"
									outlined
									dense
									label="خلال"
									hide-details></v-select>
							</v-col>
							<v-col cols="6">
								<v-text-field
									:disabled="!addVacation.withSalary"
									prepend-inner-icon="mdi-percent-outline"
									v-model.number="addVacation.discountPercentage"
									outlined
									dense
									label="نسبة الأقتطاع"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-checkbox
									v-model="addVacation.withSalary"
									class="mt-0"
									outlined
									dense
									label="مع راتب"
									hide-details></v-checkbox>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							:loading="loadingAdding"
							:disabled="loadingAdding || cantAdd"
							color="secondary"
							@click="addVacationType">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- permission types -->
		<v-dialog
			v-model="addPermissionDialog"
			:max-width="500"
			transition="dialog-transition">
			<b-add-dialog
				title="إضافة نوع الأذن"
				:headers="permissionHeaders"
				fetch-store="attendance/fetchPermissionsTypes"
				add-store="attendance/addPermissionType"
				@close="addPermissionDialog = false"
				@done="addPermissionDialog = false"></b-add-dialog>
		</v-dialog>

		<!-- mission types -->
		<v-dialog
			v-model="addMissionDialog"
			:max-width="500"
			transition="dialog-transition"
			persistent
		>
			<b-add-dialog
				title="إضافة نوع مهمة"
				:headers="missionHeaders"
				fetch-store="attendance/fetchMissionsTypes"
				add-store="attendance/addMissionType"
				@close="addMissionDialog = false"
				@done="addMissionDialog = false"></b-add-dialog>
		</v-dialog>
	</div>
</template>

<script>
import { getEnumByValue } from '@/utils/helpers';
import { vacationType, vacationFrequency } from '@/utils/enum';
import BAddDialog from '@/components/forms/BAddDialog.vue';
import { mapState } from 'vuex';

export default {
	components: { BAddDialog },

	data() {
		return {
			loading: false,
			loadingAdding: false,
			showAddVacationDialog: false,
			tableHeaders: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
				},
				{
					text: 'عدد الأيام الأعظمي',
					name: 'maxDayCount',
					value: 'maxDayCount',
				},
				{
					text: 'خلال',
					name: 'repetition',
					value: 'repetition',
					noNotAvailableText: true,
					setValueExpr: (v) => getEnumByValue(v, vacationFrequency),
				},
				{
					text: 'مع راتب',
					name: 'withSalary',
					value: 'withSalary',
					noNotAvailableText: true,
					setValueExpr: (v) => (v ? 'مع' : 'بدون'),
				},
				{
					text: 'نسبة الأقتطاع',
					name: 'discountPercentage',
					value: 'discountPercentage',
					noNotAvailableText: true,
					setValueExpr: (v) => (v ? v + '%' : '-'),
				},
				// {
				// 	text: 'عدد الموظفين المستفيدين',
				// 	name: 'employees',
				// 	value: 'employeeIds',
				// 	noNotAvailableText: true,
				// 	setValueExpr: (v) => v.length,
				// },
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 20,
					noInput: true,
					sortable: false,
				},
			],
			items: [],

			addVacation: {
				employees: [],
				forAllEmployee: true,
				name: null,
				repetition: null,
				maxDayCount: null,
				withSalary: false,
				discountPercentage: null,
			},

			addPermissionDialog: false,
			addMissionDialog: false,

			// vacations
			vacationType,
			vacationFrequency,

			permissionHeaders: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
					storeName: 'name',
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 20,
					noInput: true,
					sortable: false,
				},
			],

			// missions
			missionHeaders: [
				{
					text: 'الاسم',
					name: 'name',
					value: 'name',
					storeName: 'name',
				},
				{
					text: 'الاحتساب',
					type: 'number',
					name: 'percentage',
					value: 'percentage',
					storeName: 'percentage',
					width: 130,
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 20,
					noInput: true,
					sortable: false,
				},
			],

			itemId: null,
			deleteDialog: false,
			leaveTypeId: null
		};
	},

	watch: {
		leaveTypeId(val) {
			if(val && this.items.length !== 0) {
				this.$refs.table.resetShownRows()
				this.items.filter(c => c.id === val)
			}
		},
		'addVacation.withSalary'() {
			if (!this.addVacation.withSalary) {
				this.addVacation.discountPercentage = null;
			}
		},

		showAddVacationDialog(val) {
			if(val && this.itemId) {			
  				const item = this.items.find(c => c.id === this.itemId)
				this.addVacation.employees =  !item.forAllEmployee ? item.employeeIds : []
				this.addVacation.name = item.name
				this.addVacation.forAllEmployee = item.forAllEmployee
				this.addVacation.repetition = item.repetition
				
				this.addVacation.maxDayCount = item.maxDayCount
				this.addVacation.withSalary = item.withSalary
				this.addVacation.discountPercentage = item.discountPercentage
			}  else if(!val) {
				this.itemId = null
			} else {
				this.addVacation.employees = []
				this.addVacation.name = null
				this.addVacation.repetition = null
				this.addVacation.maxDayCount = null
				this.addVacation.withSalary = false 
				this.addVacation.discountPercentage = null
 			}
		}
	},

	computed: {
		// validation field in add vacation type dialog 
		cantAdd() {
			if (
				!this.addVacation.name ||
				!this.addVacation.maxDayCount ||
				typeof this.addVacation.repetition !== 'number' ||
				(!this.addVacation.forAllEmployee && this.addVacation.employees.length === 0)
			)
				return true;
			return false;
		},
		...mapState({
			employees: state => state.employee.employees,
			leaves: state => state.leaveOrPermission.leaves
		}),
	},

	methods: {
		clear() {
			this.addVacation = {
				employees: [],
				forAllEmployee: true,
				name: null,
				repetition: null,
				maxDayCount: null,
				withSalary: false,
				discountPercentage: null,
			};
		},
		addVacationType() {
			function isNumeric(value) {
				return /^\d+(\.\d+)?$/.test(value);
			}
			if (!isNumeric(this.addVacation.maxDayCount)) {
				this.$eventBus.$emit('show-snackbar', 'عدد الأيام الأعظمي', {
					error: true,
				});
				return;
			}
			if (this.addVacation.withSalary && !isNumeric(this.addVacation.discountPercentage)) {
				this.$eventBus.$emit('show-snackbar', 'نسبة الأقتطاع يجب ان تكون رقم', {
					error: true,
				});
				return;
			}

			this.loadingAdding = true;
			const actionName = this.itemId ? 'update' : 'create'
			this.$store
				.dispatch(`leaveOrPermission/${actionName}`, {
					name: this.addVacation.name,
					maxDayCount: this.addVacation.maxDayCount,
					withSalary: this.addVacation.withSalary,
					discountPercentage: this.addVacation.discountPercentage,
					repetition: this.addVacation.repetition,
					type: 0,
					employeeIds: this.addVacation.employees,
					id: this.itemId, 
					forAllEmployee: this.addVacation.forAllEmployee
				} )
				.then(() => {
					this.fetchVacationTypes();
					this.clear();
					this.$eventBus.$emit('show-snackbar', this.$T('messages.add-done'), {
						done: true,
					});
				})
				.catch((err) => {
					err.default && err.default(this.$T('messages.add-fail'), false);
				})
				.finally(() => {
					this.showAddVacationDialog = false;
					this.loadingAdding = false;
				});
			
		},
		fetchVacationTypes() {
			this.loading = true;
			this.$store
				.dispatch('attendance/fetchVacationsTypes')
				.then((res) => {
					this.items = res;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},

	mounted() {
		this.fetchVacationTypes();
	},
};
</script>

<style lang="scss" scoped></style>
